import { observable, makeObservable } from 'mobx';

import type { PregnancyParams } from 'chaika-frontend-types/frontend-cms';
import type { Optional } from 'chaika-common-types';
import { FieldStatus } from 'chaika-enums';

export class Pregnancy {
    @observable public id: string;
    @observable public year: Optional<number>;
    @observable public gestationalAge: Optional<string>;
    @observable public result: Optional<string>;
    @observable public status?: FieldStatus;

    constructor({ id, year, gestationalAge, result, status }: PregnancyParams) {
        makeObservable(this);

        this.id = id;
        this.year = year;
        this.gestationalAge = gestationalAge;
        this.result = result;
        this.status = status;
    }

    public serialize(): PregnancyParams {
        return {
            id: this.id,
            year: this.year,
            gestationalAge: this.gestationalAge,
            result: this.result,
            status: this.status,
        };
    }
}
